import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import "./Navbar.css";

export default function Navbar() {
  const { logout } = useContext(AuthContext);

  return (
    <nav className="navbar navbar-expand-lg navbar-aristo px-3 shadow-sm">

      {/* LOGO */}
      <Link className="navbar-brand d-flex align-items-center" to="/dashboard">
        <img 
          src="/logo-aristo-branco.png"
          alt="Aristo"
          className="navbar-logo me-2"
        />
      </Link>

      {/* CHECK-IN — sempre visível no mobile */}
      <div className="d-flex d-lg-none ms-auto me-2">
        <Link className="btn btn-light btn-sm px-3" to="/checkins">
          Check-in
        </Link>
      </div>

      {/* BOTÃO SANDUÍCHE */}
      <button
        className="navbar-toggler ms-2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* MENU DESKTOP */}
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav ms-auto gap-2 align-items-center">

          {/* CHECK-IN — sempre visível no desktop */}
          <li className="nav-item d-none d-lg-block">
            <Link className="btn btn-light btn-sm px-3" to="/checkins">
              Check-in
            </Link>
          </li>

          {/* SAIR */}
          <li className="nav-item">
            <button 
              className="btn btn-dark btn-sm px-3"
              onClick={logout}
            >
              Sair
            </button>
          </li>

        </ul>
      </div>
    </nav>
  );
}
